"use client"

import axios from 'axios'
import base_url from '../../main';
import https from "https";
import {useEffect, useState} from "react";

/**
 * If basket state changes, all states that rely on it also get updated.
 *
 * @returns {unknown}
 * @constructor
 */
import {Basket} from '../../context/basket';

const BasketProvider = ({children}) => {
    const [data, setData] = useState(null);
    const [consultationData, setConsultationData] = useState(null);
    const [initialState, setInitialState] = useState(false);

    const fetchData = async () => {
        const instance = axios.create({
            withCredentials: true,
            httpsAgent: new https.Agent({
                rejectUnauthorized: false
            })
        });
        return await instance.get(
            base_url['base_url'] + 'cart/data?XDEBUG_SESSION_START=PHPSTORM'
        );
    }

    const triggerUpdate = (retries = 0) => {
        setInitialState(true);
        if (retries <= 10) {
            fetchData()
                .then(res => {
                    setData(res.data);
                    if (typeof window !== "undefined") {
                        const dataString = res.data['customer_hash'];
                        let hash = window.localStorage.getItem('dataString');
                        if (typeof hash === "undefined" || hash === null && typeof dataString !== "undefined" && dataString !== null && dataString !== "") {
                            window.localStorage.setItem('dataString', dataString);
                        }
                    }
                })
                .catch(error => {
                    retries++;
                    return triggerUpdate(retries);
                });
        }

        if (retries === 10) {
            console.log('Too many requests');
        }
    }

    const triggerUpdateAndReturn = function (retries = 0) {
        setInitialState(true);
        let result = null;
        if (retries <= 10) {
            result = fetchData()
                .then(res => {
                    setData(res.data);
                    if (typeof window !== "undefined") {
                        const dataString = res.data['customer_hash'];
                        let hash = window.localStorage.getItem('dataString');
                        if (typeof hash === "undefined" || hash === null && typeof dataString !== "undefined" && dataString !== null && dataString !== "") {
                            window.localStorage.setItem('dataString', dataString);
                        }
                    }
                })
                .catch(error => {
                    retries++;
                    return triggerUpdateAndReturn(retries);
                });
        }

        if (retries === 10) {
            console.log('Too many requests');
            return;
        }

        return result;
    }

    useEffect(() => {
        if (initialState === false) {
            setInitialState(true);
            triggerUpdate();
        }
    });

    const { Provider } = Basket;
    return(
        <Provider value={{
            data: data,
            consultationData: consultationData,
            setConsultationData: setConsultationData,
            updateBasket: triggerUpdate,
            updateBasketReturn: triggerUpdateAndReturn
        }}>
            {children}
        </Provider>
    )
}

export default BasketProvider;